export default __webpack_public_path__ + "static/media/motB2.2f545df9.png";